import { action, observable } from 'mobx';

type NotificationType = 'success' | 'warn' | 'warning' | 'error' | 'default'| 'information' ;
type MessageType = 'notification' | 'modal';

enum buttonType {
  button = 0,
  checkbox = 1
}
export interface IButtonData {
  callback: (() => void) | ((event) => void);
  text: string;
  type?: buttonType;
  value?: any;
  cancelSharesCallback?: boolean;
}


export interface IMessageProps {
  // Required items
  title: string;
  messageContent: string;
  severity: NotificationType;
  type: MessageType;


  //Optional items
  buttonArray?: IButtonData[];
  visible?: boolean;
  infoUrl?: string;
  fullErrorCode?: string;
  shortErrorCode?: string;
  hasLocalMuteToggle?: boolean;
  canMute?: boolean;
  callingElement?;
}


export class Message {
  readonly messageTitle: string;
  readonly messageContent: string;
  readonly messageSeverity: NotificationType;
  readonly messageType: MessageType;
  @observable visible: boolean;
  readonly buttonArray: IButtonData[];
  readonly infoUrl: string | undefined;
  readonly fullErrorCode: string;
  readonly shortErrorCode: string;//Create a Message object to be used with MessageCenter alert controller.
  readonly timestamp: string;// timestamp when created. used in ErrorNotification rerender
  @observable hasLocalMuteToggle: boolean;
  @observable muted: boolean = false;
  readonly canMute: boolean;
  readonly callingElement;

  /**
   * Create a Message object to be used with MessageCenter alert controller.
   * 
   * @param {IMessageProps} messageData Message content used for an alert of type {@linkcode IMessageProps}
   */
  constructor(messageData: IMessageProps) {
    this.messageTitle = messageData.title;
    this.messageContent = messageData.messageContent;
    this.messageSeverity = messageData.severity;
    this.messageType = messageData.type;
    if (messageData.infoUrl) this.infoUrl = messageData.infoUrl;

    if (messageData.visible === undefined) this.visible = true;
    else this.visible = messageData.visible;

    // Adding optional buttons to a notification component. Will be displayed within the notification
    if (messageData.buttonArray) this.buttonArray = messageData.buttonArray;
    else this.buttonArray = [];

    if (messageData.shortErrorCode) this.shortErrorCode = messageData.shortErrorCode;
    else this.shortErrorCode = '';

    if (messageData.fullErrorCode) this.fullErrorCode = messageData.fullErrorCode;
    else this.fullErrorCode = '';
    if (messageData.hasLocalMuteToggle) {
      this.hasLocalMuteToggle = true;
    } else {
      this.hasLocalMuteToggle = false;
    }
    if (messageData.canMute) {
      this.canMute = messageData.canMute;
    }
    else {
      this.canMute = false;
    }
    if (messageData.callingElement) this.callingElement = messageData.callingElement;
    
    this.timestamp = Date.now().toString();// Date in milliseconds should provide a unique timestamp for each message.
  }

  @action.bound toggleMuteNotification() {
    this.muted = !this.muted;
  }
}
